import axios, { AxiosError } from "axios";

export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

// Endpoints that ARE the auth handshake — a 401 from these is expected
// (e.g., /whoami when no cookie exists) and must NOT trigger the redirect,
// otherwise the SignIn page would loop on itself.
const AUTH_PATH_PREFIX = "/auth/";

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const url = error.config?.url ?? "";
    const status = error.response?.status;

    if (
      status === 401 &&
      !url.startsWith(AUTH_PATH_PREFIX) &&
      window.location.pathname !== "/sign-in"
    ) {
      const returnTo = window.location.pathname + window.location.search;
      window.location.href = `/sign-in?return_to=${encodeURIComponent(returnTo)}`;
    }
    return Promise.reject(error);
  },
);
